import React from "react";
import { AbsoluteFill, interpolate, useCurrentFrame } from "remotion";
import { Terminal } from "../components/SceneChrome";
import { CONTACT } from "../data/resume";

// Scene 7 — Contact (95–100%): the terminal returns. The DOM overlay in
// AdventurePage places real clickable links over the typed CTAs.
const Scene7Contact: React.FC = () => {
  const frame = useCurrentFrame();
  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#181818",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Terminal
        width={1100}
        fontSize={32}
        lines={[
          { text: "elbert.status()", from: 2, charsPerFrame: 1.6 },
          {
            text: "status: open to opportunities",
            from: 13,
            charsPerFrame: 3,
            color: "#2E9E5B",
          },
          {
            text: `contact: ${CONTACT.email}`,
            from: 22,
            charsPerFrame: 3.5,
            color: "#fcaeea",
          },
          {
            text: "linkedin: /in/elbertwan",
            from: 30,
            charsPerFrame: 3.5,
            color: "#0EA5E9",
          },
        ]}
      />
      <div
        style={{
          marginTop: 46,
          fontFamily: "Montserrat, sans-serif",
          fontSize: 26,
          color: "#b3b3b3",
          opacity: interpolate(frame, [34, 42], [0, 1], {
            extrapolateLeft: "clamp",
            extrapolateRight: "clamp",
          }),
        }}
      >
        Thanks for scrolling the whole journey — say hi 👋
      </div>
    </AbsoluteFill>
  );
};

export default Scene7Contact;
